<template>
  <div>
    <ButtonBack class="mb_m"/>
    <input-quizset />
    <slot></slot>
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import InputQuizset from '@/components/EventQuizsetClosed/InputQuizset'

export default {
  components: {
    ButtonBack,
    InputQuizset
  }
}
</script>
